import { useState } from "react";
import {
  LayoutDashboard, Building2, Server, Hash, Users, ScrollText, Lightbulb, Settings,
} from "lucide-react";
import { Shell } from "../../components/Shell";
import { OverviewTab } from "./OverviewTab";
import { SitesTab } from "./SitesTab";
import { ServersTab } from "./ServersTab";
import { ExtensionsTab } from "./ExtensionsTab";
import { UsersTab } from "./UsersTab";
import { LogsTab } from "./LogsTab";
import { IdeasTab } from "./IdeasTab";
import { SettingsTab } from "./SettingsTab";

const NAV = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "sites", label: "Sites", icon: Building2 },
  { id: "servers", label: "SIP Servers", icon: Server },
  { id: "extensions", label: "Extensions", icon: Hash },
  { id: "users", label: "User Accounts", icon: Users },
  { id: "logs", label: "Call Logs", icon: ScrollText },
  { id: "settings", label: "Alerts & Settings", icon: Settings },
  { id: "ideas", label: "Ideas", icon: Lightbulb },
];

export default function AdminDashboard() {
  const [tab, setTab] = useState("overview");

  return (
    <Shell title="Admin Console">
      <div className="flex flex-col lg:flex-row gap-6" data-testid="admin-dashboard">
        <nav className="lg:w-56 shrink-0" data-testid="admin-nav">
          <div className="flex lg:flex-col gap-1.5 overflow-x-auto pb-2 lg:pb-0">
            {NAV.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-${item.id}-tab`}
                onClick={() => setTab(item.id)}
                className={`flex items-center gap-2.5 px-3.5 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  tab === item.id
                    ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/30"
                    : "text-slate-400 hover:text-slate-200 hover:bg-[#0F131C] border border-transparent"
                }`}
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </button>
            ))}
          </div>
        </nav>
        <div className="flex-1 min-w-0">
          {tab === "overview" && <OverviewTab goTo={setTab} />}
          {tab === "sites" && <SitesTab />}
          {tab === "servers" && <ServersTab />}
          {tab === "extensions" && <ExtensionsTab />}
          {tab === "users" && <UsersTab />}
          {tab === "logs" && <LogsTab />}
          {tab === "settings" && <SettingsTab />}
          {tab === "ideas" && <IdeasTab />}
        </div>
      </div>
    </Shell>
  );
}
